// Added by Sejune Oh on 2019-02-25
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import React, { Component } from 'react'
import { TablePaginationProps } from '@material-ui/core/TablePagination'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Define
import { ReactClickEvent } from '@/helper/define'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Component
import PaginationAction from './PaginationAction'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Interface
interface PaginationActionTableCProps {
    page: number
    count: number
    rowsPerPage: number
    onPageChange: (event: React.MouseEvent<HTMLButtonElement, MouseEvent> | null, page: number) => void
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
class PaginationActionContainer extends Component<PaginationActionTableCProps & TablePaginationProps> {
    render() {
        const { page, count, rowsPerPage } = this.props
        const isFirstPage = page === 0
        const hasNextPage = page >= Math.ceil(count / rowsPerPage) - 1

        return (
            <PaginationAction
                isFirstPage={isFirstPage}
                hasNextPage={hasNextPage}
                onFirstPageBtnClick={this.handleFirstPageButtonClick}
                onBackBtnClick={this.handleBackButtonClick}
                onNextBtnClick={this.handleNextButtonClick}
                onLastPageBtnClick={this.handleLastPageButtonClick}
            />
        )
    }

    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    handleFirstPageButtonClick: ReactClickEvent = (event) => {
        this.props.onPageChange(event as React.MouseEvent<HTMLButtonElement>, 0)
    }

    handleBackButtonClick: ReactClickEvent = (event) => {
        this.props.onPageChange(event as React.MouseEvent<HTMLButtonElement>, this.props.page - 1)
    }

    handleNextButtonClick: ReactClickEvent = (event) => {
        this.props.onPageChange(event as React.MouseEvent<HTMLButtonElement>, this.props.page + 1)
    }

    handleLastPageButtonClick: ReactClickEvent = (event) => {
        this.props.onPageChange(
            event as React.MouseEvent<HTMLButtonElement>,
            Math.max(0, Math.ceil(this.props.count / this.props.rowsPerPage) - 1)
        )
    }
}

export default PaginationActionContainer
